<template>
  <div id="load-mydata-modal-template" v-if="showModal">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container md-modal-container load-my-data-modal">
            <div class="modal-header">
              <h3 class="modal-title plus-modal-title">
                기존 수강이력 가져오기
              </h3>
              <button class="closeBtn plus-modal-close-x" @click="close">
                X
              </button>
            </div>
            <div class="modal-body">
              <div class="input-group">
                <label class="session-label">기존 이용기관</label>
                <select class="session-input" v-model="userOrg" v-on:change="orgChange" title=" 선택">
                  <option value="">기관 선택</option>
                  <option value="swc">서부/중부캠퍼스</option>
                  <option value="dsc">도심권센터</option>
                  <option value="djc">동작센터</option>
                  <option value="nwc">노원센터</option>
                  <option value="ydp">영등포센터</option>
                </select>
              </div>
              <div class="input-group" v-if="showFacebookUser">
                <label class="checkbox-inline label__radio">
                  <input class="input__checkbox" type="checkbox" v-model="facebookUser" title="페이스북 간편로그인 사용자 선택"> 페이스북 간편로그인 사용자
                </label>
              </div>
              <div v-if="!facebookUser">
                <div class="input-group">
                  <label for="id" class="session-label">아이디</label>
                  <input type="text" class="session-input" v-model="userId" placeholder="아이디" title="아이디">
                </div>
                <div class="input-group">
                  <label for="pw" class="session-label">비밀번호</label>
                  <input type="password" class="session-input" v-model="userPassword" placeholder="비밀번호" title="비밀번호">
                </div>
              </div>
              <div v-if="facebookUser">
                <div class="input-group">
                  <label class="session-label">이름</label>
                  <input type="text" class="session-input" v-model="userName" placeholder="아이디" title="아이디">
                </div>
                <div class="input-group">
                  <label class="session-label">이메일</label>
                  <input type="email" class="session-input" v-model="userEmail" placeholder="이메일" title="이메일">
                </div>
                <div class="input-group">
                  <label class="session-label">연락처</label>
                  <input type="number" class="session-input" v-model="userPhone" placeholder="연락처는 -를 빼고 숫자만 입력해주세요." title="연락처는 -를 빼고 숫자만 입력해주세요.">
                </div>
              </div>
              <br>
            </div>
            <div class="modal-footer" style="text-align: center;">
              <button class="md-btn btn--light-gray" @click="close">취소</button>
              <button type="button" class="md-btn btn--blue-line border-2" @click="getMyData">기존 수강이력 가져오기</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
  import axios from 'axios';

  export default {
    name: 'load-mydata-modal-template',
    props: ['orgList'],
    data() {
      return {
        showModal: false,
        userOrg: '',
        userId: '',
        showFacebookUser: false,
        facebookUser: false,
        userPassword: '',
        userName: '',
        userEmail: '',
        userPhone: '',
      };
    },
    methods: {
      orgChange() {
        if (this.userOrg === 'swc' || this.userOrg === 'scc') {
          this.showFacebookUser = true;
        } else {
          this.showFacebookUser = false;
          this.facebookUser = false;
        }
      },
      getMyData() {
        if (!this.userOrg) {
          alert('기관을 선택해 주세요.');
        } else if (this.facebookUser) {
          if (!this.userName) {
            alert('이름을 입력해 주세요.');
          } else if (!this.userEmail) {
            alert('이메일을 입력해 주세요.');
          } else if (!this.userPhone) {
            alert('연략처를 입력해 주세요.');
          } else {
            const Params = {
              org: this.userOrg,
              userName: this.userName,
              userEmail: this.userEmail,
              userPhone: this.userPhone,
              facebookUser: this.facebookUser,
            };
            axios.post('/api/members/transfer', Params).then(() => {
              alert('기존 수강이력을 가져왔습니다.');
              location.href = '/mypage-education-record.do';
            }).catch((e) => {
              alert(e.response.data.msg);
            });
          }
        } else if (!this.userId) {
          alert('아이디를 입력해 주세요.');
        } else if (!this.userPassword) {
          alert('비밀번호를 입력해 주세요.');
        } else {
          const Params = {
            org: this.userOrg,
            userId: this.userId,
            userPassword: this.userPassword,
          };
          axios.post('/api/members/transfer', Params).then(() => {
            alert('기존 수강이력을 가져왔습니다.');
            location.href = '/mypage-education-record.do';
          }).catch((e) => {
            alert(e.response.data.msg);
          });
        }
      },
      setButtons() {
        $('.load-data-modal').on('click', () => {
          $('body').addClass('modal-open');
          this.showModal = true;
        });
      },
      close() {
        this.showModal = false;
        $('body').removeClass('modal-open');
      },
    },
    mounted() {
      this.setButtons();
    },
  };
</script>



// WEBPACK FOOTER //
// LoadMyDataButton.vue?5d04c6f2